// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rqBy","tabsBox":"styles_tabsBox__JlFIV","createButton":"styles_createButton__3yhda"};